var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"mob_header"},_vm._l((_vm.btnList),function(item,index){return _c('li',{key:index,staticClass:"mob_header_item",on:{"click":function($event){return _vm.goPath(item)}}},[_c('img',{attrs:{"src":item.img}}),_c('div',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }